import Proxies from 'Components/proxies'
import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import CollapsibleCard from 'Components/collapsibleCard'
import { AttachFile } from '@material-ui/icons'

const OrderAttachments = props => {
  const [attachments, setAttachments] = useState([])

  const fetchAttachments = () => {
    Proxies.GET('orders/getOrderAttachments', { OrderID: props.OrderID }).then(responseJSON => {
      if (responseJSON && responseJSON.error) {
        toast.error('Fetching attachments failed', {
          autoClose: 3000
        })
      } else {
        setAttachments(responseJSON)
      }
    })
  }

  const handleDownload = async attachment => {
    Proxies.GET('orders/getAttachmentData', { OrderAttachmentID: attachment.OrderAttachmentID }).then(responseJSON => {
      const a = document.createElement('a')
      a.href = responseJSON.fileData
      a.download = responseJSON.fileName
      a.click()
    })
  }

  useEffect(() => {
    fetchAttachments()
  }, [])

  if (!attachments?.length) {
    return <></>
  }

  return (
    <CollapsibleCard startOpen={true} header={<strong>Vedhæftede filer</strong>}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
        {attachments.toReversed().map(attachment => (
          <div
            key={attachment.OrderAttachmentID}
            style={{
              width: '100%',
              position: 'relative',
              display: 'flex',
              gap: 10,
              cursor: 'pointer'
            }}
            onClick={() => handleDownload(attachment)}
          >
            <AttachFile />
            <div style={{ fontSize: 14, fontWeight: '600' }}>{attachment.fileName}</div>
          </div>
        ))}
      </div>
    </CollapsibleCard>
  )
}

export default OrderAttachments
